import React from "react";
import {withRouter} from 'react-router-dom';
import NavigationBarDesktop from './navigationBarDesktop/NavigationBarDesktop';
import NavigationBarMobile from './navigationBarMobile/NavigationBarMobile';

const NavigationBar = props => {
  const {pathname} = props.location;
  return [<NavigationBarDesktop {...props} pathname={pathname}/>,
    <NavigationBarMobile {...props} pathname={pathname}/>]
};

export default withRouter(props => <NavigationBar {...props}/>);
